<script lang="ts">
    import { getContext } from 'svelte';

    export let onOkay = () => {};
    export let onCancel = () => {};
    export let name = "ce produit";

    const { close } = getContext('simple-modal');

    let emailExp = {value: "", error: false};
    let emailRec = {value: "", error: false};
    let message = {value: "", error: false};
    let lock = false;

    /**
     * Close the modal
     */
    function _onCancel() {
        onCancel();
        close();
    }

    /**
     * Execute onOkay function in parent and close the modal
     */
    function _onOkay() {
        onOkay();
        close();
    }




</script>

<div id="form">
    <div id="title">
        <h2>Supprimer un article</h2>
    </div>
    <div id="description">
        <h3>Êtes-vous certain de vouloir supprimer <span class="product-name">{name}</span> de votre panier ?</h3>
    </div>


    <div id="submit">
        <button id="btn-ok" type="submit" on:click={_onOkay}>
            Je confirme
        </button>
        <button id="btn-cancel" on:click={_onCancel}>
            annuler
        </button>
    </div>
</div>

<style lang="scss">
  @import "../styles/variables";

    #form{
      margin: 40px;
      h2 {
        font-size: 26px;
        line-height: 30px;
        font-weight: bold;
      }
      h3{
        font-size: 18px;
        line-height: 28px;
        font-weight: bold;
      }

    .product-name{
      color: $orange
    }

      #submit{
        width: 100%;
        button{
          width: 100%;
          border:none;
          outline: none;
          border-radius: 100px;
          height: 40px;
          margin: 10px 0;
          cursor: pointer;
          font-weight: bold;
        }
        #btn-ok{
          background-color: $dark-black;
          color: white;
          &:disabled{
            background-color: $grey-darken;
            cursor: default;
          }
        }
        #btn-cancel{
          //display: none;
        }
      }
    }

    @media (max-width: 1024px) {
      #form{
        margin: 10px;
        #submit{
          button{
            height: 60px;
            font-size: 1.2rem;
          }
          #btn-cancel{
            display: block;
            background-color: $grey-light;
            color: $blue;
          }
        }
      }
    }

</style>
